var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"min-height":"70vh"}},[_c('router-view')],1),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"p-10 bottom-0 w-full"},[_c('p',{staticClass:"lato text-base text-center text-gray-800"},[_vm._v("Tecnologia SaveLeads - WDC")])])
}]

export { render, staticRenderFns }